import AuthButtons from '../../../../../pages/tabs/home/components/AuthButtons/AuthButtons';
import { useTranslation } from 'react-i18next';

const NoAuthContent = () => {
  const { t } = useTranslation(null, { keyPrefix: 'Modules:Mobile:Pages:Tabs:Orders:Components:NoAuthContent' });

  return (
    <>
      <div className="my-auto flex h-full flex-col items-center justify-center space-y-8 px-md">
        <div className="w-full px-2xl">
          <h4 className="text-brand-text-secondary text-center">{t('title')}</h4>
        </div>
        <AuthButtons className="w-full" />
      </div>
    </>
  );
};

export default NoAuthContent;
